import React from 'react'

export const ContinuationPop = ({ continuationPopActived, selectionData, selectedData, handleSelect }) => {
    return (
        <div className={`continuation-form${continuationPopActived ? ' active':''}`}>
            <div className='form-field custom-selection'>
                <h5 className="mb-10 bold">HOW DID YOU HEAR ABOUT US?</h5>
                {selectionData.map((item, index) => (
                    <button
                        type='button'
                        key={index}
                        className={`flex align-center btn--plain bold mb-10 item ${selectedData.includes(item) ? ' selected' : ''}`}
                        onClick={() => handleSelect(item)}
                    >
                        <span className='relative block mr-12'></span>
                        {item}
                    </button>
                ))}
                <button className="btn" type="submit">SUBMIT NOW!</button>
            </div>
        </div>
    )
}